import { createFileRoute } from "@tanstack/react-router";

import MeqProbeLamb from "~/pages/MeqProbeLamb";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/meq-probe/$")({
  staticData: ROUTE_STATIC.meqProbe,
  component: MeqProbeLamb,
});
